/**
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
/**
 * Date         : 2021-03-30 10:36:09
 * description  :
 * author       : tianshi
 */
import { cloneDeep } from "lodash";
import PropTypes from "prop-types"; //引入 react Props 类型声明
import React from "react";
import YxCodeMirror from "./yxCode";
import { Connection, YxComponent } from "../../YxComponent";
import Basics from "../Basics";
import "./index.less";

export let defaultProps = () => {
  return {
    disabled: false,
    placeholder: "请输入",
    change: (val) => {},
    height: 200,
    styleParam: {},
    inputParam: {
      mode: "javascript",
      theme: "default",
      nocursor: true,
      autofocus: false,
    },
  };
};

@Connection(defaultProps)
class YxCode extends YxComponent {
  constructor(props) {
    super(props);
  }

  productionHtml() {
    let { disabled, height, styleParam, inputParam } = this.props;
    let tmpProps = cloneDeep(this.props);
    tmpProps.formItemParam = {
      className: "yx-code",
    };
    // options
    tmpProps.children = (
      <YxCodeMirror
        change={(val) => tmpProps.change(val, tmpProps.id)}
        styleParam={{
          height,
          ...styleParam,
        }}
        disabled={disabled}
        inputParam={inputParam}
      />
    );

    let html = Basics.html(tmpProps);
    return html;
  }

  render() {
    return this.productionHtml();
  }
}

YxCode.propTypes = {
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  change: PropTypes.func,
  height: PropTypes.number,
  styleParam: PropTypes.object,
  // code-mirror参数配置
  inputParam: PropTypes.object,
};
YxCode.defaultProps = defaultProps();
export default YxCode;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxCode/index.js